import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Grid, Row, Col, FormControl, ControlLabel, FormGroup, Button, HelpBlock } from 'react-bootstrap';
import Checkbox from '../common/Checkbox';
import './Contact.css';

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      validName: true,
      email: '',
      validEmail: true,
      number: '',
      validNumber: true,
      message: '',
      validMessage: true,
      sendUpdates: false,
    };
  }

  onClickSubmit(e) {
    e.preventDefault();
    this.validateForm();
  }

  validateForm() {
    const {
      name,
      email,
      number,
      message,
    } = this.state;
    this.setState({
      validName: !!name,
      validEmail: !!email,
      validNumber: !!number,
      validMessage: !!message,
    });
  }

  isFormValid() {
    const valid =
      this.state.name.length > 0 &&
      this.state.validEmail &&
      this.state.email.length > 0 &&
      this.state.message.length > 0;
    return !valid;
  }

  isEmailValid(email) {
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(String(email).toLowerCase());
  }

  render() {
    return (
      <div className="contact">
        <link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css" rel="stylesheet" />
        <Grid>
          <Fade>
            <Row className="contact-distilled">
              <Col md={12} xs={12}>
                <h1 className="page-title"> Contact Distilled ID</h1>
                <h3 className="page-description">Have a query? Get in touch, {'we\'d'} love to hear from you.</h3>
              </Col>
            </Row>
          </Fade>
          <Row>
            <Fade delay={300}>
              <Col md={7} xs={12} className="form-wrapper">
                <form
                  action="https://formspree.io/info@distilledid.com"
                  method="POST"
                >
                  <FormGroup
                    id="formControlsName"
                    validationState={this.state.validName ? null : 'error'}
                  >
                    <ControlLabel>Your name</ControlLabel>
                    <FormControl
                      name="name"
                      type="text"
                      value={this.state.name}
                      placeholder="Jane Smith"
                      onChange={(e) => { this.setState({ name: e.target.value, validName: e.target.value.length > 0 }); }}
                    />
                    {!this.state.validName && <HelpBlock>Name is required</HelpBlock>}
                  </FormGroup>
                  <FormGroup
                    id="formControlsEmail"
                    validationState={this.state.validEmail ? null : 'error'}
                  >
                    <ControlLabel>Your work email</ControlLabel>
                    <FormControl
                      name="email"
                      type="text"
                      value={this.state.email}
                      placeholder="email@company.com"
                      onChange={(e) => {
                        this.setState({
                          email: e.target.value,
                          validEmail: this.isEmailValid(e.target.value),
                        });
                      }} />
                    {!this.state.validEmail && <HelpBlock>Email is required</HelpBlock>}
                  </FormGroup>
                  <FormGroup
                    id="formControlsPhone"
                    validationState={this.state.validNumber ? null : 'error'}
                  >
                    <ControlLabel>Your phone number</ControlLabel>
                    <FormControl
                      name="phone"
                      type="text"
                      value={this.state.number}
                      placeholder="Please enter your phone number"
                      onChange={(e) => { this.setState({ number: e.target.value, validNumber: e.target.value.length > 0 }); }}
                    />
                    {!this.state.validNumber && <HelpBlock>Number is required</HelpBlock>}
                  </FormGroup>

                  <FormGroup
                    id="formControlsWebsite"
                  >
                    <ControlLabel>Your website</ControlLabel>
                    <FormControl
                      name="website"
                      type="text"
                      value={this.state.website}
                      placeholder="Please enter your website (optional)"

                    />
                  </FormGroup>
                  <FormGroup
                    id="formControlsMessage"
                    validationState={this.state.validMessage ? null : 'error'}
                  >
                    <ControlLabel>Message</ControlLabel>
                    <FormControl
                      name="message"
                      componentClass="textarea"
                      rows={3}
                      placeholder="Tell us more about your project, needs and timeline."
                      value={this.state.message}
                      onChange={(e) => { this.setState({ message: e.target.value, validMessage: e.target.value.length > 0 }); }}
                    />
                    {!this.state.validMessage && <HelpBlock>Please provide a contact message</HelpBlock>}
                  </FormGroup>
                  <Checkbox
                    name="sendUpdates"
                    onChange={() => this.setState({ sendUpdates: !this.state.sendUpdates })}
                    checked={this.state.sendUpdates}
                  >
                    Send me updates about Distilled ID.
                </Checkbox>
                  <Button
                    type="submit"
                    bsClass="submit"
                    disabled={this.isFormValid()}
                  >SEND
                </Button>
                </form>
              </Col>
            </Fade>
            <Fade delay={300}>
              <Col md={5} xs={12} className="contact-wrapper">
                <div className="contact-details">
                  <Col md={12}>
                    <h4>Edinburgh Office</h4>
                  </Col>
                  <Col md={6} xs={12} className="contact-details">
                    <span>No. 2 Lochrin Square,</span>
                    <span>96 Fountainbridge</span>
                    <span>Edinburgh EH3 9QA</span>
                    <span>Scotland</span>
                  </Col>
                  <Col md={6} xs={12} className="contact-details">
                    <span>+44 (0)131 2255558</span>
                    <a className="contact-link" href="mailto:info@distilledID.com"> info@distilledID.com</a>
                    <a className="contact-link" href="mailto:info@arc-net.io"> info@arc-net.io</a>
                  </Col>
                </div>
                <div className="map-wrapper">
                  <iframe className="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2234.324490750566!2d-3.2109614840620306!3d55.943747580604786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4887c7a184e9512b%3A0x7be11e0ed5443597!2s96+Fountainbridge%2C+Edinburgh+EH3+9QA!5e0!3m2!1sen!2suk!4v1540823334773" title="google map" />
                </div>
                <Col md={12}>

                  <a className="directions-link" href="https://goo.gl/maps/Gjf1qPLfaDs">get directions</a>
                </Col>

              </Col>
            </Fade>
          </Row>
        </Grid>
      </div >
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/views/Contact.js